var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherShi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.2,
    height: 25.981,
    viewBox: "0 0 31.2 25.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6631",
    "data-name": "Group 6631",
    transform: "translate(12998.287 12320.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9032",
    "data-name": "Path 9032",
    d: "M225.742,5.893a4.172,4.172,0,0,0-5.221,3.638,4.186,4.186,0,1,0-2.047,7.836,4.058,4.058,0,0,0,.618-.05,4.182,4.182,0,0,0,5.57,2.36,7.182,7.182,0,0,0,4.972,1.781c2.75,0,5.072-1.259,5.822-2.987a4.178,4.178,0,0,0,6.378-1.769c2.132-.592,3.651-2.127,3.651-3.927,0-2.311-2.506-4.186-5.6-4.186a7.4,7.4,0,0,0-1.085.08,4.652,4.652,0,0,0-4.23-2.509,5.26,5.26,0,0,0-.619.04,4.182,4.182,0,0,0-8.211-.307",
    transform: "translate(-13212.572 -12322.706)",
    fill: "#67a4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9033",
    "data-name": "Path 9033",
    d: "M220.521,24.541a1.607,1.607,0,1,0,3.1.713c.228-.994-.84-3.432-.84-3.432s-2.028,1.725-2.257,2.719",
    transform: "translate(-13212.572 -12322.706)",
    fill: "#67a4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9034",
    "data-name": "Path 9034",
    d: "M227.052,25.854a2.03,2.03,0,1,0,3.913.9c.288-1.256-1.061-4.339-1.061-4.339s-2.564,2.181-2.852,3.437",
    transform: "translate(-13212.572 -12322.706)",
    fill: "#67a4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9035",
    "data-name": "Path 9035",
    d: "M234.758,24.541a1.606,1.606,0,1,0,3.1.713c.228-.994-.84-3.432-.84-3.432s-2.028,1.725-2.256,2.719",
    transform: "translate(-13212.572 -12322.706)",
    fill: "#67a4fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherShi);
export default __webpack_public_path__ + "static/media/weather_shi.a784c6330838b1398daae21bbf8f47fa.svg";
export { ForwardRef as ReactComponent };